module.exports = __webpack_public_path__ + "static/media/17f.c5d823db.jpg";